import { Grid } from "@mui/material";
import { memo, useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import strings from '../../../Globalization/index';
import CustomTabs from '../../../components/common/Tabs';
import consts from "../../../consts";
import { useCycleInfo } from "../../../contexts/CycleInfo/Context";
import util from "../../../util";
import Disinfection from "./Disinfection";
import FinalRinse from "./FinalRinse";
import PressureLossFlowCheck from "./PressureLossFlowCheck";
import Prewash from "./Prewash";
import Rinse from "./Rinse";
import ThermalDecontam from './ThermalDecontam';
import Wash from "./Wash";

const ProcessMonitor = () => {
	const { data } = useCycleInfo();
	const [searchParams, setSearchParams] = useSearchParams();

	const [tabs, tabNames] = useMemo(() => {

		const tabs = [];
		if (data?.ChartDetail) {
			const hasRinseAccess = util.checkAccess('RinseAccess');
			const hasWashAccess = util.checkAccess('WashAccess');
			const hasPreWashAccess = util.checkAccess('PreWashAccess');
			const hasDisinfection = util.checkAccess('Disinfection');
			const isEnspire = data?.EquipmentFamilyId === consts.EquipmentFamilyType.ENSPIRE;
			const properties = Object.keys(data.ChartDetail);
			let i = 1;
			for (const property of properties) {
				const propertyName = property.split('_')[0];
				const name = `pm-${i}`;
				switch (propertyName) {
					case 'ENDOCHECK':
					case 'ENDOCOMPLETIONCHECK':
					case 'ADDITIONALFLOWCHECK':
						tabs.push({
							name,
							label: (isEnspire && propertyName === "ENDOCHECK") ? "PRESSURELOSSCHANNELMONITOR" : (isEnspire && propertyName === "ENDOCOMPLETIONCHECK") ? "CHANNELMONITORONCOMPLETE" : `PRESSURECHECK${propertyName}`,
							Component: PressureLossFlowCheck,
							property: property,
							propertyName: propertyName
						});
						i++;
						break;
					case 'PREWASH1':
					case 'PREWASH2':
					case 'PREWASH3':
					case 'Prewash4':
						if (hasPreWashAccess) {
							tabs.push({
								name,
								label: strings[propertyName],
								Component: Prewash,
								property: property,
								propertyName: propertyName
							});
							i++;
						}
						break;
					case 'CHEMDISINFECTION1':
					case 'CHEMDISINFECTION2':
					case 'CHEMDISINFECTION3':
					case 'CHEMDISINFECTION4':
						if (hasDisinfection) {
							tabs.push({
								name,
								label: strings[propertyName],
								Component: Disinfection,
								property: property,
								propertyName: propertyName
							});
							i++;
						}
						break;
					case 'THERMALDECONTAM':
					case 'THERMALDECONTAMA0':
						tabs.push({
							name,
							label: strings[propertyName],
							Component: ThermalDecontam,
							property: property,
							propertyName: propertyName
						});
						i++;
						break;
					case 'RINSE':
					case 'RINSE1':
					case 'RINSE2':
					case 'RINSE3':
					case 'RINSE4':
						if (hasRinseAccess) {
							tabs.push({
								name,
								label: strings[propertyName],
								Component: Rinse,
								property: property,
								propertyName: propertyName
							});
							i++;
						}
						break;
					case 'WASH1':
					case 'WASH2':
					case 'WASH3':
					case 'WASH4':
						if (hasWashAccess) {
							tabs.push({
								name,
								label: strings[propertyName],
								Component: Wash,
								property: property,
								propertyName: propertyName
							});
							i++;
						}
						break;
					case 'FINALRINSE1':
					case 'FINALRINSE2':
					case 'FINALRINSE3':
					case 'FINALRINSE4':
						if (util.checkAccess('FinalRinseAccess')) {
							tabs.push({
								name,
								label: strings[propertyName],
								Component: FinalRinse,
								property: property,
								propertyName: propertyName
							});
							i++;
						}
						break;
					default:
						break;
				}
			}
		}


		const tabNames = tabs.map((tab) => tab.name);
		return [tabs, tabNames];
	}, [data]);

	const tab = useMemo(() => {
		const tabName = searchParams.has('tab') ? searchParams.get('tab') : 0;
		const tabIndex = tabNames.indexOf(tabName);
		return tabIndex !== -1 ? tabIndex : 0;
	}, [searchParams, tabNames]);


	const handleOnTabChange = useCallback(
		(event, i) => {
			if (tab !== i && tabNames[i]) {
				const searchParamsObj = {};
				for (const [key, value] of searchParams.entries()) {
					searchParamsObj[key] = value;
				}
				searchParamsObj.tab = tabNames[i];
				setSearchParams(searchParamsObj);
			}
		},
		[searchParams, tabNames, setSearchParams, tab]
	);
	return (
		!!data && <Grid container>
			<Grid size={12} >
				<CustomTabs
					tabs={tabs}
					tab={tab}
					onChange={handleOnTabChange}
				/>
			</Grid>
		</Grid>
	);
}

export default memo(ProcessMonitor);
